import axios from 'axios';
const apiUrl = import.meta.env.VITE_API_KEY;

export const axiosInstance = axios.create({
  baseURL: apiUrl,
});

// Adicione o token no cabeçalho de todas as requisições
axiosInstance.interceptors.request.use(
  (config) => {
    const token = JSON.parse(localStorage.getItem('user'));
    if (token?.acess) {
      config.headers['Authorization'] = `Bearer ${token.acess}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
